var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['common-content']},_vm._l((_vm.normalTextList),function(item){return _c('p',{key:item,class:_vm.$style['text']},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }